__webpack_require__.S = {};
var initPromises = {};
var initTokens = {};
__webpack_require__.I = (name, initScope) => {
	if(!initScope) initScope = [];
	// handling circular init calls
	var initToken = initTokens[name];
	if(!initToken) initToken = initTokens[name] = {};
	if(initScope.indexOf(initToken) >= 0) return;
	initScope.push(initToken);
	// only runs once
	if(initPromises[name]) return initPromises[name];
	// creates a new share scope if needed
	if(!__webpack_require__.o(__webpack_require__.S, name)) __webpack_require__.S[name] = {};
	// runs all init snippets from all modules reachable
	var scope = __webpack_require__.S[name];
	var warn = (msg) => {
		if (typeof console !== "undefined" && console.warn) console.warn(msg);
	};
	var uniqueName = "track-exp";
	var register = (name, version, factory, eager) => {
		var versions = scope[name] = scope[name] || {};
		var activeVersion = versions[version];
		if(!activeVersion || (!activeVersion.loaded && (!eager != !activeVersion.eager ? eager : uniqueName > activeVersion.from))) versions[version] = { get: factory, from: uniqueName, eager: !!eager };
	};
	var initExternal = (id) => {
		var handleError = (err) => (warn("Initialization of sharing external failed: " + err));
		try {
			var module = __webpack_require__(id);
			if(!module) return;
			var initFn = (module) => (module && module.init && module.init(__webpack_require__.S[name], initScope))
			if(module.then) return promises.push(module.then(initFn, handleError));
			var initResult = initFn(module);
			if(initResult && initResult.then) return promises.push(initResult['catch'](handleError));
		} catch(err) { handleError(err); }
	}
	var promises = [];
	switch(name) {
		case "default": {
			register("@amplitude/analytics-browser", "^2.34.0", () => (Promise.all([__webpack_require__.e("vendors-node_modules_amplitude_analytics-core_lib_esm_analytics-connector_js-node_modules_amp-df05b8"), __webpack_require__.e("vendors-node_modules_amplitude_analytics-browser_lib_esm_index_js")]).then(() => (() => (__webpack_require__("../../node_modules/@amplitude/analytics-browser/lib/esm/index.js"))))));
			register("@amplitude/engagement-browser", "^1.0.6", () => (__webpack_require__.e("node_modules_amplitude_engagement-browser_index_esm_js").then(() => (() => (__webpack_require__("../../node_modules/@amplitude/engagement-browser/index.esm.js"))))));
			register("@amplitude/experiment-js-client", "^1.20.3", () => (__webpack_require__.e("vendors-node_modules_amplitude_experiment-js-client_dist_experiment_esm_js").then(() => (() => (__webpack_require__("../../node_modules/@amplitude/experiment-js-client/dist/experiment.esm.js"))))));
			register("@amplitude/plugin-session-replay-browser", "^1.25.10", () => (Promise.all([__webpack_require__.e("vendors-node_modules_amplitude_analytics-core_lib_esm_analytics-connector_js-node_modules_amp-df05b8"), __webpack_require__.e("vendors-node_modules_amplitude_plugin-session-replay-browser_lib_esm_index_js")]).then(() => (() => (__webpack_require__("../../node_modules/@amplitude/plugin-session-replay-browser/lib/esm/index.js"))))));
			register("@segment/analytics-next", "^1.81.1", () => (__webpack_require__.e("vendors-node_modules_segment_analytics-next_dist_pkg_index_js").then(() => (() => (__webpack_require__("../../node_modules/@segment/analytics-next/dist/pkg/index.js"))))));
			register("react", "17.0.2", () => (__webpack_require__.e("node_modules_react_index_js").then(() => (() => (__webpack_require__("../../node_modules/react/index.js"))))));
			initExternal("webpack/container/reference/@do/current-user");
			initExternal("webpack/container/reference/@do/flippers");
			initExternal("webpack/container/reference/@do/message-bus");
		}
		break;
	}
	if(!promises.length) return initPromises[name] = 1;
	return initPromises[name] = Promise.all(promises).then(() => (initPromises[name] = 1));
};